import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AuthLayout from "@/layout/auth-layout.vue";
import AppLayout from "@/layout/app-layout.vue";
import MobileLayout from "@/layout/mobile-layout.vue";
import MobileAuthLayout from "@/layout/mobile-auth-layout.vue";
import AdminAuthLayout from "@/layout/admin-auth-layout.vue";

import RouteViewComponent from "./route-view.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/:pathMatch(.*)*",
        redirect: { name: "dashboard" },
    },
    {
        name: "admin",
        path: "/admin",
        component: AppLayout,
        children: [
            {
                name: "dashboard",
                path: "dashboard",
                meta: { title: "Home" },
                // component: () => import('@/pages/admin/dashboard/Dashboard.vue')
                component: () => import("@/pages/admin/dashboardNew/index.vue"),
            },
            {
                // src\pages\admin\talentMarket\index.vue
                name: "talentMarket",
                path: "talentMarket",
                meta: { title: "人才市场" },
                component: () => import("@/pages/admin/talentMarket/index.vue"),
            },
            {
                // src\pages\admin\robotListPage\index.vue
                name: "myRobotTable",
                path: "myRobotTable",
                meta: { title: "我的机器人" },
                component: () =>
                    import("@/pages/admin/robotListPage/index.vue"),
            },
            {
                name: "myDEmp",
                path: "myDEmp",
                meta: { title: "我的数字员工" },
                component: () => import("@/pages/admin/myDEmp/index.vue"),
            },
            {
                name: "statistics",
                path: "statistics",
                component: () => {
                    const a = 1;
                },
            },
            {
                name: "statisticsNew",
                path: "statisticsNew",
                component: () => {
                    const a = 1;
                },
            },
            {
                //点赞页面
                name: "vote",
                path: "vote",
                component: () => import("@/pages/admin/vote/index.vue"),
            },
            {
                //个人中心页面
                name: "personalCenter",
                path: "personalCenter",
                component: () =>
                    import("@/pages/admin/personalCenter/index.vue"),
            },
            {
                //个人证书查看
                name: "myCertificate",
                path: "myCertificate",
                component: () =>
                    import("@/pages/admin/dashboardNew/myCertificate.vue"),
            },
            {
                //板块主页
                name: "forum",
                path: "forum",
                meta: { title: "社区主页" },
                // component: () => import('@/pages/admin/forum/index.vue'),
                component: RouteViewComponent,
                children: [
                    {
                        name: "forumindex",
                        path: "forumindex",
                        meta: { title: "社区主页" },
                        component: () =>
                            import("@/pages/admin/forum/index.vue"),
                    },
                    // {
                    // //帖子内容
                    // name: 'postsContent',
                    // path: 'postsContent',
                    // meta:{title:'帖子详情'},
                    // component:() => import('@/pages/admin/forum/postsContent.vue')
                    // },
                    {
                        //我要发贴页面
                        name: "searchPage",
                        path: "searchPage",
                        meta: { title: "搜索页面" },
                        component: () =>
                            import("@/pages/admin/forum/searchPage.vue"),
                    },
                    {
                        //编辑帖子
                        name: "articleCompile",
                        path: "articleCompile",
                        meta: { title: "编辑帖子" },
                        component: () =>
                            import("@/pages/admin/forum/articleCompile.vue"),
                    },
                    {
                        //我要发贴页面
                        name: "publishArticle",
                        path: "publishArticle",
                        component: () =>
                            import("@/pages/admin/forum/publishArticle.vue"),
                    },
                    {
                        //主板块页面
                        name: "postsPage",
                        path: "postsPage",
                        component: RouteViewComponent,
                        // component:() => import('@/pages/admin/forum/postsPage.vue'),
                        children: [
                            {
                                //我要发贴页面
                                name: "index",
                                path: "index",
                                meta: { title: "版块主页" },
                                component: () =>
                                    import("@/pages/admin/forum/postsPage.vue"),
                            },
                            {
                                //帖子内容
                                name: "postsContent",
                                path: "postsContent",
                                meta: { title: "帖子详情" },
                                component: () =>
                                    import(
                                        "@/pages/admin/forum/postsContent.vue"
                                    ),
                            },
                        ],
                    },
                ],
            },
            {
                name: "requireManage",
                path: "requireManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "newRequire",
                        path: "newRequire",
                        component: () =>
                            import(
                                "@/pages/admin/requireManage/NewRequire.vue"
                            ),
                    },
                    {
                        name: "windowAudit",
                        path: "windowAudit",
                        component: () =>
                            import(
                                "@/pages/admin/requireManage/WindowAudit.vue"
                            ),
                    },
                    {
                        name: "sceneAudit",
                        path: "sceneAudit",
                        component: () =>
                            import(
                                "@/pages/admin/requireManage/SceneAudit.vue"
                            ),
                    },
                    {
                        name: "requireList",
                        path: "requireList",
                        component: () =>
                            import(
                                "@/pages/admin/requireManage/NewRequireList.vue"
                            ),
                    },
                ],
            },
            {
                name: "publishManage",
                path: "publishManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "publishApply",
                        path: "publishApply",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/PublishApply.vue"
                            ),
                    },
                    {
                        name: "techAudit",
                        path: "techAudit",
                        component: () =>
                            import("@/pages/admin/publishManage/TechAudit.vue"),
                    },
                    {
                        name: "officeAdminAudit",
                        path: "officeAdminAudit",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/OfficeAdminAudit.vue"
                            ),
                    },
                    {
                        name: "dEmpProfile",
                        path: "dEmpProfile",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/DEmpProfile.vue"
                            ),
                    },
                    {
                        name: "myAuditList",
                        path: "myAuditList",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/MyAuditList.vue"
                            ),
                    },
                    {
                        name: "publishApplyPython",
                        path: "publishApplyPython",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/PublishApplyPython.vue"
                            ),
                    },
                    {
                        name: "assetList",
                        path: "assetList",
                        component: () =>
                            import("@/pages/admin/assetManage/AssetList.vue"),
                    },
                    {
                        name: "assetAudit",
                        path: "assetAudit",
                        component: () =>
                            import("@/pages/admin/assetManage/AssetAudit.vue"),
                    },
                    {
                        name: "licenseList",
                        path: "licenseList",
                        component: () =>
                            import(
                                "@/pages/admin/licenseManage/LicenseList.vue"
                            ),
                    },
                    {
                        name: "licenseAudit",
                        path: "licenseAudit",
                        component: () =>
                            import(
                                "@/pages/admin/licenseManage/LicenseAudit.vue"
                            ),
                    },
                    {
                        name: "talentProfile",
                        path: "talentProfile",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/TalentProfile.vue"
                            ),
                    },
                ],
            },

            {
                name: "processManage",
                path: "processManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "processList",
                        path: "processList",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/ProcessList.vue"
                            ),
                    },
                    {
                        name: "projectList",
                        path: "projectList",
                        component: () =>
                            import(
                                "@/pages/admin/publishManage/ProjectList.vue"
                            ),
                    },
                    {
                        name: "processTakeList",
                        path: "processTakeList",
                        component: () =>
                            import(
                                "@/pages/admin/processManage/ProcessTakeList.vue"
                            ),
                    },
                    {
                        name: "projectTakeList",
                        path: "projectTakeList",
                        component: () =>
                            import(
                                "@/pages/admin/processManage/ProjectTakeList.vue"
                            ),
                    },
                    {
                        name: "jobList",
                        path: "jobList",
                        component: () =>
                            import("@/pages/admin/processManage/JobList.vue"),
                    },
                    {
                        name: "jobListPython",
                        path: "jobListPython",
                        component: () =>
                            import(
                                "@/pages/admin/processManage/JobListPython.vue"
                            ),
                    },
                    {
                        name: "jobListLocal",
                        path: "jobListLocal",
                        component: () =>
                            import(
                                "@/pages/admin/processManage/JobListLocal.vue"
                            ),
                    },
                    {
                        name: "logList",
                        path: "logList",
                        component: () =>
                            import("@/pages/admin/processManage/LogList.vue"),
                    },
                    {
                        name: "queueList",
                        path: "queueList",
                        component: () =>
                            import("@/pages/admin/processManage/QueueList.vue"),
                    },
                ],
            },
            {
                name: "statManage",
                path: "statManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "certificateList",
                        path: "certificateList",
                        component: () =>
                            import(
                                "@/pages/admin/certificateManage/CertificateList.vue"
                            ),
                    },
                    {
                        name: "courseList",
                        path: "courseList",
                        component: () =>
                            import("@/pages/admin/trainManage/courseList.vue"),
                    },
                    {
                        name: "enrollPage",
                        path: "enrollPage",
                        component: () =>
                            import(
                                "@/pages/admin/trainManage/addEnrollPage.vue"
                            ),
                    },
                    {
                        name: "robotCronList",
                        path: "robotCronList",
                        component: () =>
                            import("@/pages/admin/psyManage/robotCronList.vue"),
                    },
                ],
            },
            {
                name: "aiAppManage",
                path: "aiAppManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "skillManageList",
                        path: "skillManageList",
                        component: () =>
                            import(
                                "@/pages/admin/aiAppManage/SkillManageList.vue"
                            ),
                    },
                    {
                        name: "componentMall",
                        path: "componentMall",
                        component: () =>
                            import("@/pages/admin/componentMall/index.vue"),
                    },
                ],
            },
            {
                name: "systemManage",
                path: "systemManage",
                component: RouteViewComponent,
                children: [
                    {
                        name: "userList",
                        path: "userList",
                        component: () =>
                            import("@/pages/admin/systemManage/UserList.vue"),
                    },
                    {
                        name: "sysLogs",
                        path: "sysLogs",
                        component: () =>
                            import("@/pages/admin/systemManage/SysLogs.vue"),
                    },
                    {
                        name: "bulletin",
                        path: "bulletin",
                        component: () =>
                            import("@/pages/admin/systemManage/Bulletin.vue"),
                    },
                    {
                        name: "appMessage",
                        path: "appMessage",
                        component: () =>
                            import("@/pages/admin/systemManage/AppMessage.vue"),
                    },
                    {
                        name: "community",
                        path: "community",
                        component: () =>
                            import("@/pages/admin/systemManage/community.vue"),
                    },
                    {
                        name: "share",
                        path: "share",
                        component: () =>
                            import("@/pages/admin/systemManage/ShareList.vue"),
                    },
                    {
                        name: "voteList",
                        path: "voteList",
                        component: () =>
                            import("@/pages/admin/systemManage/VoteList.vue"),
                    },
                    {
                        name: "news",
                        path: "news",
                        component: () =>
                            import("@/pages/admin/systemManage/News.vue"),
                    },
                    {
                        name: "headquarter",
                        path: "headquarter",
                        component: () =>
                            import(
                                "@/pages/admin/systemManage/DigitalDictList.vue"
                            ),
                    },
                ],
            },
        ],
    },
    {
        path: "/auth",
        component: AuthLayout,
        children: [
            {
                name: "single-login",
                path: "single-login",
                component: () =>
                    import("@/pages/auth/single-login/SingleLogin.vue"),
            },
            {
                path: "",
                redirect: { name: "single-login" },
            },
        ],
    },
    {
        path: "/login",
        component: AdminAuthLayout,
        children: [
            {
                name: "login",
                path: "",
                component: () => import("@/pages/auth/login/Login.vue"),
            },
        ],
    },
    {
        path: "/mobile",
        component: MobileLayout,
        children: [
            {
                name: "mobilemain",
                path: "mobilemain",
                meta: { title: "MobleHome" },
                component: () =>
                    import("@/pages/mobile/dashboard/MobileMain.vue"),
            },
        ],
    },
    {
        path: "/mobileauth",
        component: MobileAuthLayout,
        children: [
            {
                name: "mobile-single-login",
                path: "mobile-single-login",
                component: () =>
                    import("@/pages/mobile/auth/MobileSingleLogin.vue"),
            },
            {
                path: "",
                redirect: { name: "mobile-single-login" },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    //  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
    routes,
});

export default router;
